import { Component } from "react";
import { TablePagination } from "../../../../../common/details-table/table-pagination.component";
import { HistoryLayout } from "../../../../../common/history/history-layout.component";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { outputConfigHistoryActions } from "../../../../../../store/external/recharge-reducer/output-configuration-reducer/output-configuration-history.reducer";
import { MODAL_CUSTOM_MESSAGE } from "../../../../../../constants/external-constants";
class OutputConfirmationHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        };
    }

    componentDidMount() {
        this.props.getOutputConfigHistoryLogs(this.props.outputConfigurationId)
    }

    componentWillUnmount() {
    }


    outputConfigurationPaginationAction = (pageIndex) => {
        const { getOutputConfigHistoryLogs, outputConfigurationId } = this.props;
        getOutputConfigHistoryLogs(outputConfigurationId, pageIndex);
    }
    onColumnSearch = () => {
        const { getOutputConfigHistoryLogs, outputConfigurationId } = this.props;
        getOutputConfigHistoryLogs(outputConfigurationId, 0)
    }
    resizePage = (pageSize) => {
        const { resizeOutputConfigHistoryLogs, getOutputConfigHistoryLogs, outputConfigurationId } = this.props;
        resizeOutputConfigHistoryLogs(pageSize)
        getOutputConfigHistoryLogs(outputConfigurationId);
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }

    onClickExtract = () => {
        const { outputConfigurationId, extractOutputConfigHistoryLogs } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractOutputConfigHistoryLogs(outputConfigurationId);
        }
    }  

    render() {
        const { setOutputConfigHistoryColSearchStr, isReadOnly, isReadAndExtractOnly, isReadAndWrite } = this.props;
        const { Headers, Data, Pagination } = this.props.outputConfigHistory.HistoryTable
        const { IsLoadingTable } = this.props.outputConfigHistory
        return (
            <HistoryLayout
                displaySearchBox={this.displaySearchBox}
                extractAction={this.onClickExtract}

                //Access Type
                isReadOnly={isReadOnly}
                isReadAndExtractOnly={isReadAndExtractOnly}
                isReadAndWrite={isReadAndWrite} 
                hideCustomColumn={true}
            >
                <TablePagination
                    key="table-pagination-key"
                    columns={Headers}
                    pageList={Data}
                    pages={Pagination}
                    paginationAction={this.outputConfigurationPaginationAction}
                    onColumnSearch={this.onColumnSearch}
                    onColumnSearchChange={setOutputConfigHistoryColSearchStr}
                    isColSearchShow={this.state.enableSearchBox}
                    resizePage={this.resizePage}
                    totalPage={Pagination?.TotalEntries}
                    isNotSortable={true}
                    isLoading={IsLoadingTable}
                    hideStatusIcon={true}
                    hidePageSizeSelection={Data.TotalCount === 0 ? true : false}
                />
            </HistoryLayout>
        );
    }
}
export default connect(
    state => {
        const { outputConfigHistory } = state;
        return {
            outputConfigHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, outputConfigHistoryActions),
        dispatch
    )
)(OutputConfirmationHistory);